const etapas = [
  { n: '01', titulo: 'Entendimento do ambiente', texto: 'Uso, circulação e necessidades do espaço.' },
  { n: '02', titulo: 'Levantamento de área', texto: 'Medição e análise das condições do piso.' },
  { n: '03', titulo: 'Escolha da solução', texto: 'Definição do sistema mais adequado ao projeto.' },
  { n: '04', titulo: 'Definição de paginação e acabamento', texto: 'Composição de cores, padrões e acabamentos.' },
  { n: '05', titulo: 'Proposta', texto: 'Escopo, produtos e serviços estruturados.' },
  { n: '06', titulo: 'Fornecimento e instalação', texto: 'Coordenação logística e implantação do piso.' },
];

export default function ProjetoSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Projeto
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Do levantamento à instalação.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {etapas.map((e) => (
            <div
              key={e.n}
              className="bg-white border border-background-200/60 rounded-2xl p-7 hover:border-primary-300 transition-colors"
            >
              <span className="text-primary-500 text-[14px] font-bold tracking-wider">{e.n}</span>
              <h3 className="text-foreground-900 text-[16px] font-semibold mt-3 mb-2">
                {e.titulo}
              </h3>
              <p className="text-foreground-500 text-[14px] leading-relaxed">{e.texto}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-background-100/60 border border-background-200/60 rounded-2xl p-6 md:p-8">
          <div className="flex items-start gap-4">
            <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 flex-shrink-0">
              <i className="ri-information-line text-xl"></i>
            </span>
            <p className="text-foreground-600 text-[14px] md:text-[15px] leading-relaxed">
              As condições do contrapiso e a preparação necessária são analisadas conforme cada
              obra. O desempenho final do piso depende do preparo adequado da base, do produto
              especificado e da correta execução da instalação.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}